import React from "react";
import { Box } from "@mui/material";

const GradientInputBox = ({ children }) => (
  <Box
    sx={{
      borderRadius: '40px',
      padding: '.5px',
      background: 'linear-gradient(90deg, #50FADC 0%, #2563EB 100%)',
      marginBottom: '0px',
    }}
  >
    <Box
      sx={{
        height: '50px',
        borderRadius: '40px',
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '16px',
        paddingRight: '16px',
        fontFamily: 'inherit'
      }}
    >
      {children}
    </Box>
  </Box>
);

export default GradientInputBox;
